import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';
import useRequest from 'hooks/useRequest';
import { getUserAssessmentAnswers } from 'services/user';

import contentIcon from 'images/content.png';
import quizIcon from 'images/quiz.png';
import reflectionIcon from 'images/reflection.png';
import videoIcon from 'images/video.png';
import { AssessmentAnswersComponentProps } from 'modals/AssessmentAnswers';

import * as S from './styles';

import { SessionsTableProps } from '.';

const ActivitiesTable: React.FC<SessionsTableProps> = ({ data, cognitoId }) => {
  const { openModal } = useModals();
  const request = useRequest();

  const getIcon = (typeTopic: string) => {
    const icons = [
      { key: 'quiz', value: quizIcon },
      { key: 'video', value: videoIcon },
      { key: 'content', value: contentIcon },
      { key: 'article', value: contentIcon },
      { key: 'reflection', value: reflectionIcon },
    ];
    const icon = icons.find(item => {
      return item.key === typeTopic;
    });
    return icon?.value;
  };

  const getActivitiesAnswers = async (
    cogId: string,
    formId: string,
    title: string,
  ) => {
    request.setLoading();
    try {
      const {
        data: { url },
      } = await getUserAssessmentAnswers(cogId, formId);

      openModal<AssessmentAnswersComponentProps>('assessmentAnswers', {
        props: {
          title,
          url,
        },
      });

      request.setSuccess();
    } catch (e) {
      request.setError(e);
    }
  };

  if (!data.length) {
    return <></>;
  }
  return (
    <S.TableContainer data-testid="tableActivities">
      {data.map(item => (
        <S.TableItem key={item.id}>
          <tbody>
            <S.TableItemDesc>
              <S.TableItemTitle data-testid="programTitle">
                {item.title}
              </S.TableItemTitle>
              <S.TableItemType>
                <S.TopicIcon src={getIcon(item.type)} alt="icon" /> {item.type}
              </S.TableItemType>
            </S.TableItemDesc>
            <S.TableItemStatus
              data-testid="topicStatus"
              isFinished={item?.acknowledge}
            >
              <FormattedMessage
                id={
                  item?.acknowledge
                    ? 'ACTIVITIES.STATUS.FINISHED'
                    : 'ACTIVITIES.STATUS.NOTSTATERD'
                }
              />
            </S.TableItemStatus>
            <S.TableItemAction>
              <S.ViewButton
                disabled={item?.external_form_id === '' || !item?.acknowledge}
                isView={item?.external_form_id !== '' && item?.acknowledge}
                data-testid="buttonViewAnswers"
                onClick={() =>
                  getActivitiesAnswers(
                    cognitoId,
                    item?.external_form_id,
                    item.title,
                  )
                }
              >
                <FormattedMessage id="ACTIVITIES.TABLE.BUTTON" />
              </S.ViewButton>
            </S.TableItemAction>
          </tbody>
        </S.TableItem>
      ))}
    </S.TableContainer>
  );
};

export { ActivitiesTable };
